<template>
	<b-card id="BuscadorProductosPresentacionRango" bg-variant="dark">
		<div slot="header">Selecciona la persentación y rango de búsqueda</div>
		<b-row class="mb-0">
			<b-col>
				<b-row>
					<b-col md="12" lg="5">
						<b-form-select id="filtra-por-categoria" :options="catsMain" v-model="workingValue.categoria" class="mb-2" aria-invalid=""/>
					</b-col>
					<b-col md="12" lg="7">
						<b-form-input id="presentacionInputSearch" v-model="workingValue.presentacionIdPk"></b-form-input>
					</b-col>
				</b-row>
			</b-col>
			<b-col md="5" lg="6">
				<b-row>
					<b-col>
						<b-form-datepicker id="inicio-del-reporte" placeholder="Inicio del reporte" class="mb-0" :max="workingValue.rangeEnd" v-model="workingValue.rangeStart"></b-form-datepicker>
					</b-col>
					<b-col>
						<b-form-datepicker id="fin-del-reporte" placeholder="Fin del reporte" class="mb-0" :min="workingValue.rangeStart" v-model="workingValue.rangeEnd"></b-form-datepicker>
					</b-col>
				</b-row>
			</b-col>
            <!-- <b-col md="1">
                <b-button variant="primary">Aplicar</b-button>
            </b-col> -->
		</b-row>
	</b-card>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import mobiscroll from "@mobiscroll/javascript";
import moment from 'moment'
let startObj = {
	categoria: '*',
	presentacionIdPk: null,
	rangeStart: null,
	rangeEnd: null,
};
export default {
	name: "BuscadorProductosPresentacionRango",
	props: {
		catsMain: {
			type: Array,
			default: []
		},
		value: {
			type: Object,
			default: () => {
				return _.clone(startObj);
			},
		},
	},
	data: () => {
		return {
			workingValue: _.clone(startObj),
			backupCat: '*',
			mobiInput: null,
			mobiCat: null,
		};
	},
	beforeMount() {
		if (
			!!this.value &&
			typeof this.value == "object" &&
			!!this.value.presentacionIdPk &&
			!!this.value.rangeStart &&
			!!this.value.rangeEnd
		) {
			this.workingValue.presentacionIdPk = _.clone(
				this.value.presentacionIdPk
			);
			this.workingValue.rangeStart = _.clone(this.value.rangeStart);
			this.workingValue.rangeEnd = _.clone(this.value.rangeEnd);
		} else {
			this.workingValue.rangeStart = moment().add(-92, 'day').format('YYYY-MM-DD');
			this.workingValue.rangeEnd = moment().add(-2, 'day').format('YYYY-MM-DD');
		}
	},
	mounted() {
		this.loadMobi();
		this.setMobiConfg()
	},
	updated() {
		this.try2emmit();
	},
	methods: {
		setMobiConfg(){
			// console.log("typeof this.mobiInput.options", typeof this.mobiInput.option)
			if(typeof this.mobiInput == 'object' && typeof this.mobiInput.option == 'function')
				this.mobiInput.option({data: {
					remoteFilter: true,
					url: axios.defaults.baseURL + "/producto/busquedawidthcat/" + this.workingValue.categoria + "/",
					type: "json",
					processResponse: (response) => {
						this.fullData = [];
						if (response.status && response.data) {
							this.fullData = _.map(response.data, (item) => {
								return {
									value: item.id,
									item,
									text:
										item.elemento +
										" " +
										item.presentacion +
										" " +
										item.unidadmedicion +
										" " +
										item.marca +
										" " +
										item.tipopresentacion,
									html:
										'<div style="font-size:16px;line-height:18px;">' +
										item.elemento +
										" " +
										item.presentacion +
										" " +
										item.unidadmedicion +
										'</div><div style="font-size:10px;line-height:12px;">' +
										item.marca +
										", " +
										item.tipopresentacion +
										"</div>",
								};
							});
						} else {
							this.fullData = [
								{
									value: null,
									item: {},
									text: "Nada encontrado",
									html: "<p>Nada encontrado</p>",
								},
							];
						}
						return this.fullData;
					},
				}});
			else {
				console.log('MobiInput indefinido')
			}
		},
		loadMobi() {
			this.mobiInput = mobiscroll.select("#presentacionInputSearch", {
				display: "bubble",
				filter: true,
				inputClass: "form-control",
				placeholder: "Busca un producto específico",
				onSet: (event, inst) => {
					this.workingValue.presentacionIdPk = inst.getVal();
				},
			});
		},
		try2emmit() {
			if (
				(!!this.workingValue.presentacionIdPk || !!this.workingValue.categoria) && (!!this.workingValue.rangeStart && !!this.workingValue.rangeEnd)
			) {
				this.$emit("input", this.workingValue);
			} else {
				this.$emit("input", null);
			}
		}
	},
	watch:{
		'value.categoria'(){
			if(this.backupCat != this.value.categoria){
				this.mobiInput.clear()
				this.setMobiConfg()
				this.backupCat = _.clone(this.value.categoria)
			}
		}
	}
};
</script>

<style lang="less">
#BuscadorProductosPresentacionRango {
}
</style>